import {LineItem} from '../models/line.items/lineItem.model';

export namespace LineItemsActions {
  export class GetLineItems {
    static readonly type = '[Line Items api] Get Line Items';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class UpdateLineItems {
    static readonly type = '[Line Items api] Update Line Items';

    constructor(public id: string, public lineItems: LineItem[]) {
    }
  }
}
